import React from 'react' 

import { COLORS, SKIP_TITLES } from '../Constants'
import { useStateValue } from './StateProvider'
import { capitalizeText, getRowColor } from '../Utils'

const Legend = () => {
    const [{ darkmode, legendTitles, selected }] = useStateValue()

    return (
        <div className='legend'>
            {legendTitles.map((title, index) => {
                if (!SKIP_TITLES.includes(title)) {
                    return <p className='legend__label' style={{
                        backgroundColor: getRowColor(COLORS, darkmode, index),
                        padding: selected !== null && '4px'
                    }}>{capitalizeText(title.replace(/([A-Z])/g, ' $1').trim())}</p> 
                } 
            })}
        </div>
    )
}

export default Legend